import { render, staticRenderFns } from "./ContacTanos.vue?vue&type=template&id=65efe770&scoped=true"
import script from "./ContacTanos.vue?vue&type=script&lang=js"
export * from "./ContacTanos.vue?vue&type=script&lang=js"
import style0 from "./ContacTanos.vue?vue&type=style&index=0&id=65efe770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65efe770",
  null
  
)

export default component.exports